module.exports = __webpack_public_path__ + "images/stickers/pete-love@2x.6e461f2c1917d10063fb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-love@2x.png
// module id = 86Yg
// module chunks = 12